<template>
    <div id="novel_info">
        <div class="novel_success1 cursor_1" @click="toNovellist">
            <img src="@/assets/image/icon_right.png" alt="">
            作品信息
        </div>
        <div class="novel_info">
            <div class="novel_info1">
                <div class="novel_info1_1">
                    <img :src="novelInfo.img" alt="">
                </div>
                <!-- <div class="novel_info1_2 cursor_1" >
                    <span @click="openCover">更换封面</span>
                    <span class="t-p-l-10" @click="downloadImg">图片下载</span>
                </div> -->
                <div class="novel_info1_2 cursor_1" @click="openCover">
                    <span>更换封面</span>
                </div>
            </div>
            <div class="novel_info2">
                <div class="novel_info2_15">
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            书号
                        </div>
                        <div class="novel_info2_3">
                            {{ novelInfo.id }}
                        </div>
                    </div>
                    <!-- 作品名称 -->
                    <!-- <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>作品名称
                        </div>
                        <div class="novel_info2_3">
                            <el-input v-model="novelInfo.scriptName" ref="djzpm" :maxlength="150" show-word-limit
                                placeholder="请输入作品名称"></el-input>
                            <div class="novel_info2_14 cursor_1" @click="openPopup('作品名称', 0)"></div>
                            <div class="loading_text" v-if="streamStatus && requireIndex == 0">
                                <img src="@/assets/image/loading.png" alt="">
                            </div>
                        </div>
                    </div> -->
                    <!-- 核心受众 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>核心受众
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_4" v-for="(item, i) in sex" :key="i"
                                @click.stop="getSex(item.value)">
                                <img
                                    :src="novelInfo.sex && novelInfo.sex.includes(item.value) ? iconSelect[1] : iconSelect[0]" />
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                    <!-- 作品类型 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>作品类型
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_6 cursor_1" v-if="novelInfo.typeName" @click="openLabel3">
                                {{ novelInfo.typeName }}
                                <img :src="iconSelect[4]" @click.stop="delLabel(0, '类型')" alt="">
                            </div>
                            <div v-if="!novelInfo.typeName" class="novel_info2_7 cursor_1" @click="openLabel3">
                                <img :src="iconSelect[3]" alt="">
                                {{ novelInfo.typeName ? '更换类型' : '添加类型' }}
                            </div>
                        </div>
                    </div>

                    <!-- 作品风格 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            <span>*</span>作品风格
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_5">
                                <div class="novel_info2_6 cursor_1" v-for="(item, i) in novelInfo.stylisticNames"
                                    :key="i" @click="openLabel4">
                                    {{ item }}
                                    <img :src="iconSelect[4]" @click.stop="delLabel(i, '风格')" alt="">
                                </div>
                                <div v-if="novelInfo.stylisticNames && novelInfo.stylisticNames.length < 10"
                                    class="novel_info2_7 cursor_1" @click="openLabel4">
                                    <img :src="iconSelect[3]" alt="">
                                    添加标签
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- 生成集数 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            短剧集数
                        </div>
                        <div class="novel_info2_3">
                            <span>{{ novelInfo.chaptersNumber + '集' }}</span>
                        </div>
                    </div>
                    <!-- 每集时长 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2"> 每集时长</div>
                        <div class="novel_info2_3">
                            <span>{{ novelInfo.duration + '分钟' }}</span>
                        </div>
                    </div>
                    <!-- 作品状态 -->
                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                            作品状态
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_4" v-for="(item, i) in novelStatus" :key="i"
                                @click.stop="getStatus(i)">
                                <img :src="novelInfo.status === i ? iconSelect[1] : iconSelect[0]" />
                                {{ item }}
                            </div>
                        </div>
                    </div>
                    <!-- 后端动态生成表单内容 -->
                    <!-- {{ novelInfo }} -->
                    <template v-for="(item, index) in curForm">
                        <div :key="index" class="novel_info2_1" v-if="item.display">
                            <div class="novel_info2_2" v-if="!item.required">{{ item.name }}<span>(非必填)</span></div>
                            <div class="novel_info2_2" v-else><span>*</span>{{ item.name }}</div>
                            <div class="novel_info2_3">
                                <el-input v-if="item.name === '作品名称'" v-model="novelInfo[item.key]"
                                    :ref="item.writeType" :maxlength="150" show-word-limit placeholder="请输入作品名称">
                                </el-input>
                                <el-input v-else v-model="novelInfo[item.key]" type="textarea" :ref="item.writeType"
                                    :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="item.maxLength" show-word-limit
                                    :placeholder="item.placeholder">
                                </el-input>
                                <!-- 停止生成按钮 -->
                                <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                    v-if="streamStatus && requireCurItem.key === item.key && item.name !== '作品名称'">
                                </AIStopCreate>
                            </div>
                            <div class="novel_info2_114 cursor_1" v-if="item.helpWrite" @click="openPopup(index, item)">
                            </div>
                            <div class="loading_text_script" v-if="streamStatus && requireCurItem.key == item.key">
                                <img src="@/assets/image/loading.png" alt="">
                            </div>
                        </div>
                        <div class="novel_create6"></div>
                    </template>


                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info2_8">严禁上传任何抄袭、涉黄、涉赌、涉毒、涉政、涉黑等违规内容。一经查实，全书屏蔽整改 并取消福利，情节严重的会追究其法律责任。
                            </div>
                        </div>
                    </div>


                    <div class="novel_info2_1">
                        <div class="novel_info2_2">
                        </div>
                        <div class="novel_info2_3">
                            <div class="novel_info20">
                                <el-button class="novel_info2_9" :loading="loading" type="warning" @click="submit">
                                    <span v-if="isCopy">{{ loading ? '克隆中...' : '克隆小说' }}</span>
                                    <span v-else>{{ loading ? '正在修改...' : '提交修改' }}</span>
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <novelCover ref="createCover" @changeCover="changeCover" @opne="opne"></novelCover>
        <createLabel ref="createLabel" @getLable="getLable" />
        <createLabel2 ref="createLabel2" @getLable="getLable2" />
        <createLabel3 ref="createLabel3" @getLable="getLable3" />
        <createLabel4 ref="createLabel4" @getLable="getLable4" />
        <createHelp ref="createHelp" @getRequire="getRequire" />
        <delPpopup ref="delPpopup" @confirm="confirm"></delPpopup>
    </div>
</template>

<script>

import data from '@/assets/data';
import novelCover from "@/components/script/novel_cover.vue" //更换封面
import createLabel from '@/components/novel_create_label.vue';
import createLabel2 from '@/components/novel_create_label2.vue';
import createLabel3 from '@/components/novel_create_label3.vue';
import createLabel4 from '@/components/novel_create_label4.vue';
import createHelp from '@/components/novel_create_help.vue';
import api from '@/api/api';
import SApi from '@/api/script'
import longNovel from '@/api/longNovel';
import delPpopup from '@/components/del_popup.vue';
import _ from 'lodash'
// import {downloadImage} from '@/utils/utils'
export default {
    components: {
        novelCover, createLabel, createHelp, delPpopup, createLabel2, createLabel3, createLabel4
    },
    data() {
        return {
            ifModify: false,//表单内容是否修改状态
            novelInfo: {
                sex: [],//核心受众
                typeName: '',//作品类型
                stylisticNames: [], //文笔风格,接口是string类型，提交的时候进行转换就行了，使用数据更适合处理业务逻辑
                chaptersNumber: '',//集数
                duration: '',//时长
                scriptName: '',//作品名称
                protagonistNames: '',//角色设定
                introduction: '',//作品简介
                requirement: '',//要求
            },//小说信息
            oldNoveInfo: {},//保存初始化的数据
            sex: data.scriptSex, //性别
            result: ['完整结局', '开放结局'],//小说结局
            resultText: ['选择“完整结局”,最后一章将为小说提供一个明确的结局', '选择“开放结局”,故事将保留伏笔,便于后续续写或连载'],
            resultIndex: 0, //小说结局index
            chapterText: '支持百万字小说连载:作品首次创建时支持一次性生成最多100章节，生成完成后，用户可在现有 框架下无限续写章节。',
            iconSelect: data.iconSelect, //图标
            requireIndex: null, //帮写要求 0作品名称 1角色信息 2作品简介
            novelStatus: ['连载', '完结'],
            //必填项字段,移除单选按钮这些，进行验证
            verify: ['typeName', 'stylisticNames', 'chaptersNumber', 'duration', 'scriptName', 'protagonistNames', 'introduction'],
            options: [], //类型
            viewList: ['第一人称', '第三人称'],//写作视角集合
            lengthList: ['中长篇小说', '短篇小说'],//篇幅设定列表
            streamStatus: false, //流式请求
            streamIndex: 0, //流式请求下标
            streamLast: false, //流式最后一条
            debounceTimer: null, //防抖定时器
            typingTimer: null, // 打字效果定时器
            maxChapterLen: 100,
            durationLen: 30,//每集时长最高30
            durationMin: 2,//每集时长最低2
            refType: null,//ai生成的滚动
            isCopy: false,
            loading: false,//加载
            curForm: [],//自定义的文本内容
            appendFormData: [{
                "name": "作品名称",
                "key": "scriptName",
                "helpWrite": true,
                "writeType": "script_name",
                "required": true,
                "sort": 5,
                "display": true,
                "placeholder": "请输入作品名称",
                "maxLength": 150
            },
            {
                "name": "角色信息",
                "key": "protagonistNames",
                "helpWrite": true,
                "writeType": "script_role",
                "required": true,
                "sort": 6,
                "display": true,
                "placeholder": "请输入角色信息",
                "maxLength": 10000
            },
            {
                "name": "作品要求",
                "key": "requirement",
                "helpWrite": false,
                "writeType": "",
                "required": false,
                "sort": 7,
                "display": true,
                "placeholder": "请输入您对作品的其他要求，例如:您偏爱的写作风格、独特的世界观、巧妙的伏笔、跌宕起伏的情节，以及想要探讨的主题深度等",
                "maxLength": 3000
            }
                , {
                "name": "作品简介",
                "key": "introduction",
                "helpWrite": true,
                "writeType": "script_introduction",
                "required": true,
                "sort": 8,
                "display": true,
                "placeholder": "请输入作品简介",
                "maxLength": 3000
            }
            ]
        }
    },
    created() {
        this.isCopy = this.$route.query?.copy
        this.successNovelId = this.$route.query?.successNovelId || ''
        this.init()

    },
    beforeDestroy() {
        this.clearTime()
    },
    methods: {
        init() {
            longNovel.initLongNovelFromParams({ md: 'script' }).then((res) => {
                if (res.code == 200) {
                    if (res.data && res.data.length > 0) {
                        this.curForm = res.data.concat(this.appendFormData)
                        this.curForm = this.curForm.filter(item => {
                            this.$set(this.novelInfo, item.key, '')
                            if (item.required && item.display) {
                                this.verify.push(item.key)
                            }
                            return item
                        })
                        this.getNovelinfo()
                    }
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        downloadImg() {
            // downloadImage(this.novelInfo.img, this.novelInfo.name+'.png')
        },
        copy(status) {
            this.isCopy = status
            console.log('copys=', this.isCopy);
        },
        //返回true代表不能编辑，false代表可以编辑
        isEditor() {
            //如果是克隆就代表都可以编辑
            if (this.isCopy) {
                return false
            }
            if (!this.novelInfo.hasOwnProperty('thereAnOutline')) return false
            return this.novelInfo.thereAnOutline
        },
        toNovellist() {
            if (!this.editorIsEqual()) {
                this.$refs.delPpopup.openPrompt(3)
            } else {
                this.$router.go(-1)
            }
        },
        //打开封面
        openCover() {
            this.$refs.createCover.open(this.novelInfo.id)
        },
        //切换封面
        changeCover(item) {
            SApi.imgEdit({
                scriptId: this.novelInfo.id,
                img: item
            }).then((res) => {
                if (res.code == 200) {
                    this.novelInfo.img = item
                    this.$message.success('修改封面成功！')
                }
            })
        },

        //获取小说信息
        getNovelinfo() {
            SApi.scriptInfo(this.successNovelId).then((res) => {
                if (res.code == 200) {
                    res.data?.settings.forEach(item => {
                        this.$set(this.novelInfo, item.key, item.content)
                    });
                    this.novelInfo = { ...this.novelInfo, ...res.data }
                    this.novelInfo.scriptName = this.novelInfo.name
                    this.novelInfo.protagonistNames = this.novelInfo.protagonistNames?.[0] ?? '无'
                    this.novelInfo.typeName = this.novelInfo.styleName
                    this.oldNoveInfo = _.cloneDeep(this.novelInfo);
                } else {
                    this.$message.warning(res.msg)
                }
            })

        },
        //检测用户是否已经编辑了
        editorIsEqual() {
            console.log(this.novelInfo)
            return _.isEqual(this.novelInfo, this.oldNoveInfo)
        },
        //小说结局类型
        // getResult(i) {
        //     this.resultIndex = i
        //     this.novelInfo.done = this.resultIndex == 0 ? 'complete' : 'open'
        // },
        // 核心受众
        getSex(value) {
            let index = this.novelInfo.sex.indexOf(value)
            if (index != -1) {
                this.novelInfo.sex.splice(index, 1)
            } else {
                this.novelInfo.sex.push(value)
            }
        },
        getStatus(i) {
            if (this.novelInfo.status === i) return
            this.novelInfo.status = i
        },
        // 作品类型
        getTypeName(value) {
            //如果有大纲就不能进行编辑
            if (this.novelInfo.thereAnOutline) return
            this.novelInfo.typeName = value[1]
        },
        //帮写提示
        openPopup(i, item) {
            if (!this.validateForm(i, item)) {
                return;
            }
            this.requireCurItem = item
            this.$refs.createHelp.open(item.name);
        },
        //销毁定时器
        clearTime() {
            clearTimeout(this.debounceTimer);
            clearInterval(this.typingTimer);
            this.streamStatus = false
            this.streamLast = false
            this.streamIndex = 0
            this.refType = null
        },
        // 封装验证逻辑到独立函数
        validateForm(i, item) {
            const validationRules = [
                {
                    condition: () => this.streamStatus,
                    message: '请等待AI生成结束！'
                },
                {
                    condition: () => !this.novelInfo.sex.length,
                    message: '请选择核心受众！'
                },
                {
                    condition: () => this.novelInfo.typeName === '',
                    message: '请选择作品类型！'
                },
                {
                    condition: () => this.novelInfo.stylisticNames.length === 0,
                    message: '请选择作品风格！'
                },
                {
                    condition: () => !Number(this.novelInfo.chaptersNumber),
                    message: '请输入生成集数！'
                },
                {
                    condition: () => {
                        if (Number(this.novelInfo.chaptersNumber) && Number(this.novelInfo.chaptersNumber) > this.maxChapterLen) {
                            this.novelInfo.chaptersNumber = this.maxChapterLen
                            return true
                        }
                        return false
                    },
                    message: `生成集数超过${this.maxChapterLen}，已同步最高生成集数`
                },
                {
                    condition: () => !Number(this.novelInfo.duration),
                    message: '请输入每集时长！'
                },
                {
                    condition: () => {
                        if (this.novelInfo.duration && Number(this.novelInfo.duration) < this.durationMin) {
                            this.novelInfo.duration = this.durationMin
                            return true
                        }
                        return false
                    },
                    message: `每集时长小于${this.durationMin}分，已同步最低时长`
                },
                {
                    condition: () => {
                        if (this.novelInfo.duration && Number(this.novelInfo.duration) > this.durationLen) {
                            this.novelInfo.duration = this.durationLen
                            return true
                        }
                        return false
                    },
                    message: `每集时长超过${this.durationLen}分，已同步最高时长`
                },
                {
                    //判断自定义内容的逻辑
                    condition: () => {
                        let msg = ''
                        if (!item.required) return msg
                        let btArr = this.curForm.filter(v => v.required && v.display)
                        let curIndex = btArr.findIndex(i => i.name === item.name)
                        // console.log('btArr=', btArr.length,'curIndex===',curIndex)
                        //直接从第2个开始
                        if (curIndex === 0) return msg
                        let flag = {}
                        for (let j in btArr) {
                            if (!this.novelInfo[btArr[j].key].trim()) {
                                flag = { index: j, name: btArr[j].name, msg: `请输入${btArr[j].name}` }
                                break
                            }
                        }
                        // console.log('flag=', flag)
                        if (Object.keys(flag).length > 0) {
                            if (curIndex === flag.index && curIndex === btArr.length - 1) {
                                // console.log("这是最后一个元素且满足flag条件");
                                msg = flag.msg
                            } else {
                                if (curIndex > flag.index) {
                                    // console.log("这是在当前之前的某一个");
                                    msg = flag.msg
                                } else {
                                    //这是当前的逻辑
                                }
                            }
                        }
                        return msg
                    },
                    message: ''
                },
                {
                    //作品名称
                    condition: () => i == 2 && !this.novelInfo.scriptName.trim(),
                    message: '请填写作品名称'
                },

            ];

            for (const rule of validationRules) {
                //特殊处理
                if (!rule.message) {
                    let msg = rule.condition()
                    console.log('msg=', msg)
                    if (msg) {
                        this.$message({
                            message: msg,
                            type: 'warning'
                        });
                        return false;
                    }
                    return true
                } else {
                    if (rule.condition()) {
                        this.$message({
                            message: rule.message,
                            type: 'warning'
                        });
                        return false;
                    }
                }

            }
            return true;
        },
        //帮写提示词
        getRequire(item) {
            const baseParams = {
                ...this.novelInfo,
                menAndWomen: this.novelInfo.sex.join(','),//性别
                style: this.novelInfo.typeName,//作品类型
                label: this.novelInfo.stylisticNames.join(','),//作品风格
                name: this.novelInfo.scriptName,
                novelName: this.novelInfo.scriptName,
                scriptName: this.novelInfo.scriptName,
                protagonists: this.novelInfo.protagonistNames,
                platform: 1,//平台
                requirement: item, //弹窗填写的内容
                scriptId: this.successNovelId,//小说id
            };
            //帮写要求 0作品名称 1角色信息 2作品简介
            if (Object.keys(this.requireCurItem).length > 0) {
                this.novelInfo[this.requireCurItem.key] = ''
                this.getStream(this.requireCurItem.writeType, baseParams);
            }
        },
        getStream(type, params) {
            this.AIWrite({
                length: '中',
                haveId: false,
                // djold: true,
                type: type,
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // api.novelHelpWrite(aiType, params).then((res) => {
            //     if (res.code === 200) {
            //         this.streamStatus = true
            //         this.refType = type
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     }else{
            //         this.$message.warning(res.msg)
            //     }
            // })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex,this.AIStreamType).then((res) => {
                    if (res.code === 200) {
                        if (res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            let combinedText = '';
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item;
                                }
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamLast = true
                                }
                                if (this.streamLast) {
                                    this.clearTime()
                                    // sessionStorage.removeItem('streamStatus');
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！');
                                } else {
                                    this.getStreamContent(id);
                                }
                            });
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTime()
                    }
                }).catch(() => {
                    this.refType = null
                });
            }, 500);
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) {
                clearInterval(this.typingTimer);
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    if (Object.keys(this.requireCurItem).length > 0) {
                        this.novelInfo[this.requireCurItem.key] += text[index]
                    }

                    index++;
                    this.$nextTick(() => {
                        const inputRef = this.$refs[this.requireCurItem.writeType];
                        if (!inputRef) return;
                        const inputInstance = Array.isArray(inputRef) ? inputRef[0] : inputRef;
                        const textarea = inputInstance?.$el?.querySelector('.el-textarea__inner');
                        if (textarea) {
                            // 滚动到底部
                            console.log(10)
                            textarea.scrollTop = textarea.scrollHeight;
                        }
                    });
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) {
                        callback();
                    }
                }
            }, 20);
        },
        // 选择标签
        openLabel() {
            this.$refs.createLabel.openLable(this.novelInfo.labels);
        },
        // 选择文笔风格标签
        openLabel2() {
            this.$refs.createLabel2.openLable(this.novelInfo.style);
        },
        // 选择文笔风格标签
        openLabel3() {
            this.$refs.createLabel3.openLable(this.novelInfo.typeName);
        },
        //作品风格标签
        openLabel4() {
            this.$refs.createLabel4.openLable(this.novelInfo.stylisticNames);
        },
        // 获取标签
        getLable(i) {
            this.novelInfo.labels = i
        },
        // 获取文笔风格
        getLable2(i) {
            this.novelInfo.style = i
        },
        // 获取作品类型
        getLable3(i) {
            this.novelInfo.typeName = i
        },
        getLable4(i) {
            this.novelInfo.stylisticNames = i
        },
        // 删除标签
        delLabel(i, type) {
            this.$confirm('是否删除标签？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (type === '标签') {
                    this.novelInfo.labelNames.splice(i, 1)
                } else if (type === '风格') {
                    this.novelInfo.stylisticNames.splice(i, 1)
                } else if (type === '类型') {
                    this.$set(this.novelInfo, 'typeName', '')
                    this.novelInfo.typeName = ''
                }
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //小说状态
        getStatus(i) {
            this.novelInfo.status = i
        },
        submit() {
            if (this.streamStatus) {
                this.$message({
                    message: '请等待AI生成结束！',
                    type: 'warning'
                });
                return
            }
            let item = _.cloneDeep(this.novelInfo);
            //公共的验证
            // console.log('item=', item);
            item.scriptId = item.id
            // item.stylisticNames = item.stylisticNames.join(',')
            // item.sex = item.sex.join(',')
            if (!item.sex.length) {
                this.$message.warning(`请选择核心受众`);
                return
            }
            if (!item.typeName) {
                this.$message.warning(`请选择作品类型`);
                return
            }
            if (!item.stylisticNames.length) {
                this.$message.warning(`请选择作品风格`);
                return
            }
            if (!item.chaptersNumber) {
                this.$message.warning(`请输入生成集数`);
                return
            }
            if (Number(item.chaptersNumber) > this.maxChapterLen) {
                this.$message.warning(`生成集数超过${this.maxChapterLen}，已同步最高生成集数`);
                this.novelInfo.chaptersNumber = this.maxChapterLen
                return
            }
            if (!item.duration) {
                this.$message.warning(`请输入每集时长`);
                return
            }
            if (Number(item.duration) < this.durationMin) {
                this.$message.warning(`每集时长低于${this.durationMin}分，已同步最低时长`);
                this.novelInfo.duration = this.durationMin
                return
            }
            if (Number(item.duration) > Number(this.durationLen)) {
                this.$message.warning(`每集时长超过${this.durationLen}分，已同步最高时长`);
                this.novelInfo.duration = this.durationLen
                return
            }
            for (let i in this.curForm) {
                let objItem = this.curForm[i]
                if (item.hasOwnProperty(objItem.key) && objItem.required && objItem.display) {
                    if (!item[objItem.key].trim()) {
                        this.$message.warning(`请输入${objItem.name}`);
                        return
                    }
                }
            }
            //在进行组合后端接收的格式
            // this.appendFormData(a=>{
            //     delete item[a.key]
            // })
            const removeKeys = new Set(this.appendFormData.map(obj => obj.key));

            //后台动态的数据
            let data = this.curForm.filter(obj => !removeKeys.has(obj.key));
            let settings = []
            data.forEach(c => {
                let obj = {
                    ...c,
                    "name": c.name,
                    "key": c.key,
                    "content": item[c.key] || '无'
                }
                settings.push(obj)
                //移除item里面动态参数
                delete item[c]
            })
            item.settings = settings
            item.protagonistNames = [item.protagonistNames]
            this.loading = true
            console.log('item=', item);
            if (this.isCopy === 'true') {
                 delete item.id
                 delete item.scriptId
                SApi.djNovelAdd(item).then((res) => {
                    if (res.code === 200) {
                        localStorage.removeItem(this.cacheKey)
                        this.$router.replace({ path: '/scriptSuccess', query: { successNovelId: res.data } })
                    } else {
                        this.$message.warning(res.msg)
                    }
                }).finally(() => {
                    this.loading = false
                })
            } else {
                SApi.djNovelUpdate(item).then((res) => {
                    if (res.code == 200) {
                        this.$message.success('作品修改成功')
                        this.oldNoveInfo = _.cloneDeep(this.novelInfo);
                        // this.$router.go(-1)
                        this.$router.replace('/scriptList')
                    } else {
                        this.$message.warning(res.msg)
                    }
                }).finally(() => {
                    this.loading = false
                })
            }


        },
        confirm() {
            // this.$refs.createCover.delConfirm()
            // this.$emit('toNovellist')
            this.$router.go(-1)
        },
        opne() {
            this.$refs.delPopup.openPrompt(0)
        },
        //停止生成
        stop(name, index) {
            this.$message.success('AI已停止生成！')
            this.clearTime()
        }

    }
}
</script>

<style>
.novel_info2_1 .el-textarea .el-input__count,
.novel_info2_1 .el-input .el-input__count .el-input__count-inner {
    background: transparent;
}

#novel_info {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 10px;
    padding: 35px 30px;
}

.novel_info {
    width: 100%;
    height: calc(100% - 45px);
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.novel_info1 {
    display: flex;
    flex-flow: column;
    align-items: center;
}

.novel_info1_1 {
    width: 200px;
    height: 267px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 10px;
}

.novel_info1_1 img {
    width: 100%;
    object-fit: cover;
}

.novel_info1_2 {
    width: 85px;
    height: 25px;
    line-height: 25px;
    /* background: url('../assets/image/icon_create5.png') no-repeat; */
    background-size: 21px 21px;
    background-position: left center;
    font-size: 15px;
    color: #333333;
    display: flex;
}

.novel_info1_2 span:hover {
    /* background: url('../assets/image/icon_create6.png') no-repeat; */
    background-size: 21px 21px;
    background-position: left center;
    color: var(--tech-primary);
}

.novel_info2 {
    width: 100%;
    padding-right: 60px;
    height: 100%;
    margin-left: 20px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.novel_info2_15 {
    width: 800px;
}

.novel_info2_1 {
    display: flex;
    margin-bottom: 15px;
    position: relative;
}

.novel_info2_2 {
    width: 150px;
    font-size: 16px;
    color: #0B0B0B;
    text-align: end;
    margin-right: 20px;
    flex-shrink: 0;
}

.novel_info2_2 span {
    color: #FF3030;
}

.novel_info2_3 {
    flex: 1;
    font-size: 16px;
    color: #0B0B0B;
    display: flex;
    align-items: center;
    position: relative;
}

.novel_info2_4 {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #111111;
    margin-right: 10px;
    cursor: pointer;
}

.novel_info2_4 img {
    width: 19px;
    height: 19px;
    margin-right: 8px;
}

.novel_info3 {
    padding-left: 85px;
    font-size: 13px;
    color: #888888;
    margin-bottom: 15px;
}

.el-input--suffix .el-input__inner::-webkit-input-placeholder,
.novel_info2_3 .el-input__inner::-webkit-input-placeholder,
.novel_info2_3 .el-textarea__inner::-webkit-input-placeholder {
    color: #777777;
    /* 提示字颜色 */
    font-weight: 400;
    font-size: 15px !important;
}

.novel_info2_3 .el-input__inner,
.novel_info2_3 .el-textarea__inner {
    width: 695px;
    background-color: #F6F6F6;
    resize: none;
    font-size: 15px;
}

.novel_info2_5 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.novel_info2_6 {
    background: var(--tech-btn-Lightblue);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 5px 8px;
    font-size: 15px;
    color: var(--tech-primary);
    margin-right: 10px;
    margin-bottom: 10px;
}

.novel_info2_6 img {
    width: 13px;
    height: 13px;
    margin-left: 5px;
}

.novel_info2_7 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: var(--tech-primary);
    padding: 5px 0;
    margin-bottom: 10px;
}

.novel_info2_7 img {
    width: 19px;
    height: 19px;
    margin-right: 5px;
}

.novel_info2_8 {
    width: 695px;
    padding: 13px;
    background-color: #FFEBEB;
    border-radius: 4px;
    font-size: 13px;
    color: #FF3030;
}

.novel_info20 {
    display: flex;
    justify-content: flex-end;
    width: 695px;
    border-radius: 4px;
}

.novel_info2_9 {
    width: 125px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    color: #FFF;
    margin-top: 10px;
}

.novel_info2_9>span {
    font-size: 15px;
}

.novel_info2_11 {
    width: 100%;
    display: flex;
    justify-content: end;
    border: 1px solid red;
}

.novel_info2_12 {
    margin-left: 85px;
}

.novel_info2_13 {
    padding-left: 85px;
    font-size: 13px;
    color: #548AFF;
    margin-top: 10px;
    margin-bottom: 20px;
}

.novel_info2_14 {
    position: absolute;
    right: -60px;
    top: 0;
    width: 58px;
    height: 25px;
    background: url('@/assets/image/icon_create1.png') no-repeat;
    background-size: 100% 100%;
}

.novel_info2_114 {
    position: absolute;
    right: -122px;
    top: 0;
    width: 58px;
    height: 25px;
    background: url('@/assets/image/icon_create1.png') no-repeat;
    background-size: 100% 100%;
}

.novel_info2_14:hover {
    background: url('@/assets/image/icon_create2.png') no-repeat;
    background-size: 100% 100%;
}

.noEditor {
    filter: grayscale(100%);
    opacity: 0.7;
    /* 可选视觉提示 */
    cursor: not-allowed !important;
    position: relative;

}

.noEditor .noClick {
    pointer-events: none;
}

.loading_text {
    position: absolute;
    right: -100px;
    top: 3px;
    width: 19px;
    height: 19px;
}

.loading_text_script {
    position: absolute;
    right: -144px;
    top: 3px;
    width: 19px;
    height: 19px;
}

.loading_text,
.loading_text_script img {
    width: 100%;
    height: 100%;
    animation: rotate 1s linear infinite;
}

/* 定义旋转动画 */
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>